export default __webpack_public_path__ + "static/media/pvn-arte-9.9fb48d6e.webp";